import React from 'react';
import { withRouter } from 'react-router-dom';

import './OrganizationsMenu.css';

import OrganizationsMenuItem from '../OrganizationsMenuItem';
import OrganizationsMenuNewButton from '../OrganizationsMenuNewButton';

const OrganizationsMenu = ({ organizations, activeRoute, location }) => {
  const organizationsElem = organizations.map((organization) => {
    const isActive = location.pathname.includes(`/organizations/${organization.key}`);

    return (
      <OrganizationsMenuItem
        key={organization.key}
        organization={organization}
        isActive={isActive}
      />
    );
  });

  return (
    <div className="OrganizationMenu__idle">
      <OrganizationsMenuNewButton />
      <ul className="OrganizationMenu__idle__ul">
        { organizationsElem }
      </ul>
    </div>
  );
};

export default withRouter(OrganizationsMenu);



// WEBPACK FOOTER //
// ./src/components/OrganizationsMenu/OrganizationsMenu.jsx